/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DialogContainer from '../../../../../components/shared/Dialog/DialogContainer';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import RouterUserCreationForm from './RouterUserCreationForm';
import { getAllRouterUserList } from '../../../../../store/reducers/router/routerAction';
import { createRouterUser } from '../../../../../services/router/routerController';

const RouterUserCreation = ({ routerName }) => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);



    // Handle form submission
    const handleSubmit = async (values) => {
        try {
            await createRouterUser({
                "routerName": routerName,
                "userPass": values.password,
                "userName": values.userName,
            });
            toast.success('User was created successfully');
            await dispatch(getAllRouterUserList()).unwrap();

            handleClose();

        } catch (error) {
            toast.error(error?.response?.data?.error?.message);

            handleClose();

        }
    };
    return (
        <>
            <Button variant="contained" color="primary" style={{ float: 'right' }} onClick={handleOpen}>Create user in {routerName}</Button>
            {/* Dialog for Adding User */}
            <DialogContainer
                open={open}
                handleClose={handleClose}
            >
                <Box sx={{ mt: 2 }}>
                    <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Create user in {routerName}</Typography>

                    <Formik
                        initialValues={{
                            userName: '',
                            password: '',
                            confirmPassword: '',

                        }}
                        validationSchema={Yup.object().shape({
                            confirmPassword: Yup.string().min(8).max(30).oneOf([Yup.ref('password'), null], 'Passwords must match').required('password is required'),
                            userName: Yup.string().min(2).max(40).required('User Name is required.'),

                            password: Yup.string().min(6).max(40).required('Password is required.'),
                        })}
                        onSubmit={(
                            values
                        ) => {
                            handleSubmit(values)
                        }
                        }
                    >
                        {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                            <RouterUserCreationForm
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                isSubmitting={isSubmitting}
                                handleClose={handleClose}
                                errors={errors}
                                touched={touched} />)}
                    </Formik>
                </Box>

            </DialogContainer>
        </>
    )

}

export default RouterUserCreation;
